import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getProjectsContent, projectdislike, projectlike, ratingToProject } from '../../Apis/index';

export const FreelancerDashboardBest = createAsyncThunk('FreelancerDashboardBest', async ({ formData, token }, { rejectWithValue }) => {
    try {
        const response = await getProjectsContent(formData, token);
        return response;
    } catch (error) {
        return rejectWithValue(error.response);
    }
});



export const FreelancerProjectLike = createAsyncThunk('freelancerprojectlike', async ({ formData, token }, { rejectWithValue }) => {
    try {
        const response = await projectlike({ formData, token });
        return response;
    } catch (error) {
        return rejectWithValue(error.response);
    }
});


export const FreelancerRating = createAsyncThunk('FreelancerRating', async ({ formData, token }, { rejectWithValue }) => {
    try {
        const response = await ratingToProject({ formData, token });
        return response;
    } catch (error) {
        return rejectWithValue(error.response);
    }
});



const freelancedashboardSlice = createSlice({
    name: 'freelancedashboard',
    initialState: {
        error: null,
        success: false,
        data: [],

        error2: null,
        success2: false,

    },
    reducers: {
        clearFreelancedashboardStatus: state => {
            state.success = false;
            state.error = null;
            state.error2 = null;
            state.success2 = false;
        },

        clearDashData: state => {
            state.data = [];
        }
    },
    extraReducers: builder => {
        builder
            .addCase(FreelancerDashboardBest.pending, state => {
                state.error = null;
                state.success = false;
            })
            .addCase(FreelancerDashboardBest.fulfilled, (state, action) => {
                state.success = action.payload;
                state.error = null;
                state.data = action.payload.data.data;
            })
            .addCase(FreelancerDashboardBest.rejected, (state, action) => {
                state.error = action.payload;
                state.success = false;
            })

            .addCase(FreelancerProjectLike.pending, state => {
                state.error2 = null;
                state.success2 = false;
            })
            .addCase(FreelancerProjectLike.fulfilled, (state, action) => {
                state.success2 = action.payload;
                state.error2 = null;
            })
            .addCase(FreelancerProjectLike.rejected, (state, action) => {
                state.error2 = action.payload;
                state.success2 = false;
            })
            .addCase(FreelancerRating.pending, state => {
                state.error2 = null;
                state.success2 = false;
            })
            .addCase(FreelancerRating.fulfilled, (state, action) => {
                state.success2 = action.payload;
                state.error2 = null;
            })
            .addCase(FreelancerRating.rejected, (state, action) => {
                state.error2 = action.payload;
                state.success2 = false;
            })

    },

});
export const { clearFreelancedashboardStatus, clearDashData } = freelancedashboardSlice.actions;
export default freelancedashboardSlice.reducer;

